import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["extraField"]

  check(event) {
    const selected = event.target.value

    // ✅ Mostra solo se l'utente seleziona "altro"
    this.extraFieldTarget.classList.toggle("d-none", selected !== "altro")
  }
}
